!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this._isOpen = !1, this._targetId = "", this._showElement = null, this._hideElement = null;
    }
    connectedCallback() {
      this._targetId = this.getAttribute("target") || "", this._showElement = this.querySelector("[data-show]"), 
      this._hideElement = this.querySelector("[data-hide]"), this._showElement && this._hideElement && (this._hideElement.classList.add("hidden"), 
      this._showElement.addEventListener("click", (() => this._toggle(!0))), this._hideElement.addEventListener("click", (() => this._toggle(!1))), 
      this.hasAttribute("data-open") && this._toggle(!0));
    }
    _toggle(e = null) {
      const t = document.getElementById(this._targetId);
      t ? (this._isOpen = null !== e ? e : !this._isOpen, this._isOpen ? (t.classList.remove("hidden"), 
      this._showElement.classList.add("hidden"), this._hideElement.classList.remove("hidden")) : (t.classList.add("hidden"), 
      this._showElement.classList.remove("hidden"), this._hideElement.classList.add("hidden")), 
      this.dispatchEvent(new CustomEvent("toggle", {
        bubbles: !0,
        detail: {
          isOpen: this._isOpen,
          targetId: this._targetId
        }
      }))) : console.error(`Target element with ID '${this._targetId}' not found.`);
    }
    open() {
      this._toggle(!0);
    }
    close() {
      this._toggle(!1);
    }
    toggle() {
      this._toggle();
    }
    get isOpen() {
      return this._isOpen;
    }
  }
  customElements.get("external-toggle") || customElements.define("external-toggle", e);
}();